import { filter } from 'rxjs';
import { AfterViewInit, Component, DestroyRef, ElementRef, HostListener, ViewChild, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Sidebar } from '../../../shared/navigation';

@Component({
  selector: 'app-app-shell',
  imports: [RouterOutlet, Sidebar],
  templateUrl: './app-shell.html',
  styleUrl: './app-shell.scss',
})
export class AppShell implements AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  @ViewChild('contentScroll') private readonly contentScroll?: ElementRef<HTMLDivElement>;

  readonly isSidebarCollapsed = signal(false);
  readonly isMobileSidebarOpen = signal(false);
  readonly isMobile = signal(this.#getIsMobile());

  ngAfterViewInit() {
    queueMicrotask(() => {
      this.#scrollContentToTop();
    });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.#scrollContentToTop();
      });
  }

  @HostListener('window:resize')
  onResize() {
    const mobile = this.#getIsMobile();
    this.isMobile.set(mobile);

    if (!mobile) {
      this.isMobileSidebarOpen.set(false);
    }
  }

  toggleSidebar() {
    this.isSidebarCollapsed.update((current) => !current);
  }

  toggleMobileSidebar() {
    this.isMobileSidebarOpen.update((current) => !current);
  }

  closeMobileSidebar() {
    this.isMobileSidebarOpen.set(false);
  }

  #scrollContentToTop() {
    this.contentScroll?.nativeElement.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  #getIsMobile() {
    return typeof window !== 'undefined' && window.matchMedia('(max-width: 920px)').matches;
  }
}
